export default {
	getPropById: (state) => (id) => {
		return state.list.find(l => l.id === id)
	},
	propExists: (state) => (id) => {
		return state.list.some(l => l.id === id)
	},
	multiples: (state) => {
		// eslint-disable-next-line eqeqeq
		return state.list.filter(l => l.multiplo == 1)
	},
	simples: (state) => {
		// eslint-disable-next-line eqeqeq
		return state.list.filter(l => l.multiplo == 0)
	},
	notValidProps: (state) => {
		const invalids = []

		const simple = (attr, prop) => {
			if (!attr || attr.length === 0) {
				invalids.push({ id: prop.id, nome: prop.nome })
			}
		}

		const multi = (attrs = [], prop) => {
			if (!attrs.length) {
				invalids.push({ id: prop.id, nome: prop.nome })
			} else {
				const found = attrs.find(a => a.length === 0)
				if (!found && !attrs.length) {
					invalids.push({ id: prop.id, nome: prop.nome })
				}
			}
		}
		state.list.forEach(prop => {
			if (prop.obrigatorio) {
				try {
					prop.multiplo ? multi(prop.data.valor, prop) : simple(prop.data.valor, prop)
				} catch (error) {
					console.error('Erro ao validar propriedades.', error)
					return error
				}
			}
		})
		return invalids
	}
}
